import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes, faBuilding, faMapMarkerAlt, faUser, faCar, faTools, faCalendarAlt, faFileInvoiceDollar, faClock, faCircleInfo, faTrash, faBell, faEnvelope, faMobileAlt, faUserGroup, faCheck } from '@fortawesome/free-solid-svg-icons';
import EmployeeSelect from '../EmployeeSelect';
import VehicleSelect from '../VehicleSelect';
import EquipmentSelect from '../EquipmentSelect';
import axios from 'axios';
import { closeModal, setSwap, setModal, setHasToRefresh, swapModal, selectRightModalOldState } from '../../redux/rightModalSlice';
import { useDispatch, useSelector } from 'react-redux';
import DynamicIcon from '../DynamicIcon';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { getNodeApiUrl } from '../../config/api.config';
import { useColorPalette } from '../../hooks/useColorPalette';

// Componente per modificare un appuntamento nel pannello laterale
export default function ViewAppointment({ appointment, initialEditMode = false }) {
    const dispatch = useDispatch();
    const accountData = useSelector((state) => state.account.data);
    const rightModalOldState = useSelector(selectRightModalOldState);
    const palette = useColorPalette();
    const [jobDetails, setJobDetails] = useState(null);
    const [assistanceData, setAssistanceData] = useState(null);
    const [maintenanceData, setMaintenanceData] = useState(null);
    const [customerEmails, setCustomerEmails] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingExtra, setIsLoadingExtra] = useState(false);
    const [error, setError] = useState(null);
    const [extraDataError, setExtraDataError] = useState(null);
    
    // Stati per la modalità modifica
    const [editedAppointment, setEditedAppointment] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedVehicles, setSelectedVehicles] = useState([]);
    const [selectedEquipments, setSelectedEquipments] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    
    // Stato per memorizzare il numero di appuntamenti nella serie
    const [groupAppointmentsCount, setGroupAppointmentsCount] = useState(0);
    
    // Effetto per aggiungere stili CSS per i dropdown di react-select
    useEffect(() => {
        const styleId = 'react-select-z-index-styles';
        
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.innerHTML = `
                /* Z-index progressivo per i dropdown dei selettori */
                .collaboratori-wrapper .employee-select__menu {
                    z-index: 9999 !important;
                }
                .veicoli-wrapper .employee-select__menu,
                .veicoli-wrapper .vehicle-select__menu {
                    z-index: 9998 !important;
                }
                .attrezzature-wrapper .employee-select__menu,
                .attrezzature-wrapper .equipment-select__menu,
                .attrezzature-wrapper .vehicle-select__menu {
                    z-index: 9997 !important;
                }
                
                /* Assicuriamo che i container siano posizionati relativamente */
                .collaboratori-wrapper,
                .veicoli-wrapper,
                .attrezzature-wrapper {
                    position: relative;
                    margin-bottom: 20px;
                }
                
                /* Risolvi il problema dei menu dropdown di react-select */
                .collaboratori-wrapper [class$="-menu"] {
                    z-index: 9999 !important;
                }
                
                .veicoli-wrapper [class$="-menu"] {
                    z-index: 9998 !important;
                }
                
                .attrezzature-wrapper [class$="-menu"] {
                    z-index: 9997 !important;
                }
                
                /* Assicurati che i portali siano in ordine corretto */
                #react-select-modal-portal-1 {
                    z-index: 9999 !important;
                }
                #react-select-modal-portal-2 {
                    z-index: 9998 !important;
                }
                #react-select-modal-portal-3 {
                    z-index: 9997 !important;
                }
            `;
            document.head.appendChild(style);
        }
        
        return () => {
            const styleElem = document.getElementById(styleId);
            if (styleElem) styleElem.remove();
        };
    }, []);
    
    // Stati per la gestione dell'eliminazione
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteMode, setDeleteMode] = useState('single'); // 'single' o 'group'
    const [isDeleting, setIsDeleting] = useState(false);
    
    // Lo stato editMode determina se mostrare il form di modifica o la vista dettagli
    const [editMode, setEditMode] = useState(false); // inizia in modalità visualizzazione, non modifica
    const [editGroupMode, setEditGroupMode] = useState(false); // true se si modifica l'intera pianificazione
    const [showGroupEditModal, setShowGroupEditModal] = useState(false); // Modale per chiedere se modificare il gruppo
    
    // Stati per le notifiche
    const [sendEmployeeEmail, setSendEmployeeEmail] = useState(false);
    const [sendEmployeePush, setSendEmployeePush] = useState(false);
    const [selectedCustomerEmails, setSelectedCustomerEmails] = useState([]);
    
    // Gestisce il caso in cui il componente venga aperto con initialEditMode=true
    // (ad esempio quando si clicca su "Modifica Appuntamento" in AppointmentDetailsModal)
    useEffect(() => {
        console.log('ViewAppointment montato - initialEditMode:', initialEditMode);
        console.log('Appuntamento:', appointment);
        
        if (initialEditMode && appointment) {
            console.log('Componente aperto in modalità modifica (initialEditMode=true)');
            
            // Se editType è già stato specificato (dalla modale AppointmentDetailsModal), usalo direttamente
            if (appointment.editType) {
                console.log('editType già specificato:', appointment.editType);
                startEditMode(appointment.editType === 'all');
            } else if (appointment.groupId) {
                // Solo se editType non è specificato E ha groupId, mostra la modale
                console.log('Appuntamento con groupId:', appointment.groupId);
                setTimeout(() => {
                    setShowGroupEditModal(true);
                }, 100);
            } else {
                console.log('Appuntamento senza groupId, avvio modifica singola');
                startEditMode(false); // modalità singola
            }
        }
    }, [initialEditMode, appointment?._id]); // dipende da initialEditMode e appointment

    // Inizializza lo stato di modifica quando l'appuntamento cambia
    useEffect(() => {
        if (appointment) {
            setEditedAppointment({
                ...appointment,
                fromDate: appointment.fromDate ? new Date(appointment.fromDate).toISOString().split('T')[0] : null,
                toDate: appointment.toDate ? new Date(appointment.toDate).toISOString().split('T')[0] : null,
                fromTime: appointment.fromDate ? new Date(appointment.fromDate).toTimeString().slice(0, 5) : "09:00",
                toTime: appointment.toDate ? new Date(appointment.toDate).toTimeString().slice(0, 5) : "18:00",
            });
            // Formatto i dati degli utenti nel formato corretto per il componente Select
            // IMPORTANTE: userId è l'ID dell'utente nel database User, _id è l'ID del subdocument
            setSelectedUsers((appointment.users || []).map(user => ({
                value: user.userId || user._id || user.id,
                label: user.userLabel || `${user.name || ''} ${user.surname || ''}`,
                color: user.userColor || user.color || '#7367f0',
                data: { ...user, _id: user.userId || user._id, color: user.userColor || user.color || '#7367f0' }
            })));
            
            // Formatto i dati dei veicoli nel formato corretto per il componente Select
            setSelectedVehicles((appointment.vehicles || []).map(vehicle => ({
                value: vehicle._id || vehicle.id || vehicle.vehicleId,
                label: vehicle.vehicleLabel || vehicle.vehicleName || 'Veicolo',
                data: vehicle
            })));
            
            // Formatto i dati delle attrezzature nel formato corretto per il componente Select
            setSelectedEquipments((appointment.equipments || []).map(equipment => ({
                value: equipment._id || equipment.id || equipment.equipmentId,
                label: equipment.equipmentLabel || equipment.equipmentName || 'Attrezzatura',
                data: equipment
            })));
        }
    }, [appointment]);
    
    // La validazione è ora gestita direttamente nei componenti input, come in JobScheduling.jsx
    
    // Funzione per iniziare la modifica di un appuntamento
    const handleEditClick = () => {
        console.log('Edit click - appointment:', appointment);
        console.log('Has groupId?', !!appointment.groupId);
        // Verifica se l'appuntamento fa parte di un gruppo (ha groupId)
        if (appointment.groupId) {
            console.log('Opening group edit modal for groupId:', appointment.groupId);
            setShowGroupEditModal(true);
        } else {
            console.log('Starting single appointment edit mode');
            // Se non fa parte di un gruppo, procedi direttamente con la modifica singola
            startEditMode(false);
        }
    };
    
    // Gestisce la scelta dell'utente sulla modale di modifica gruppo
    const handleGroupEditChoice = (editEntireGroup) => {
        console.log('Group edit choice made:', editEntireGroup ? 'entire group' : 'single appointment');
        // Chiudi la modale e imposta la modalità di modifica appropriata
        setShowGroupEditModal(false);
        startEditMode(editEntireGroup);
    };
    
    // Configura lo stato per la modifica dell'appuntamento
    const startEditMode = (groupMode) => {
        // Imposta la modalità di modifica (gruppo o singolo appuntamento)
        setEditGroupMode(groupMode);
        setEditMode(true);
        
        // Se è modalità gruppo, dobbiamo recuperare tutti gli appuntamenti della serie
        if (groupMode && appointment.groupId) {
            // Avvia la modalità di caricamento
            setIsLoading(true);
            
            // Recupera tutti gli appuntamenti del gruppo per trovare il primo e l'ultimo
            const fetchGroupAppointments = async () => {
                try {
                    const token = localStorage.getItem('installamelo-auth-token');
                    const apiEndpoint = `/appointments/group/${appointment.groupId}`;
                    const endpoint = getNodeApiUrl(apiEndpoint);
                    
                    const response = await axios.get(endpoint, {
                        headers: {
                            'Content-Type': 'application/json',
                            'auth-token': token
                        }
                    });
                    
                    if (response.data && response.data.appointments && response.data.appointments.length > 0) {
                        const groupAppointments = response.data.appointments;
                        console.log('Appuntamenti del gruppo recuperati:', groupAppointments.length);
                        
                        // Ordina gli appuntamenti per data
                        groupAppointments.sort((a, b) => new Date(a.fromDate) - new Date(b.fromDate));
                        
                        // Trova il primo e l'ultimo appuntamento della serie
                        const firstAppointment = groupAppointments[0];
                        const lastAppointment = groupAppointments[groupAppointments.length - 1];
                        
                        console.log('Primo appuntamento della serie:', firstAppointment.fromDate);
                        console.log('Ultimo appuntamento della serie:', lastAppointment.fromDate);
                        console.log('Numero totale di appuntamenti nella serie:', groupAppointments.length);
                        
                        // Calcola il numero di giorni lavorativi tra il primo e l'ultimo appuntamento
                        // Questo è fondamentale per traslare correttamente gli appuntamenti nel tempo
                        const startDate = new Date(firstAppointment.fromDate);
                        const endDate = new Date(lastAppointment.fromDate);
                        const workingDaysInSeries = getWorkingDaysBetweenDates(startDate, endDate);
                        
                        console.log('Giorni lavorativi tra primo e ultimo appuntamento:', workingDaysInSeries);
                        
                        // Salva sia il numero di appuntamenti che il numero di giorni lavorativi
                        setGroupAppointmentsCount(workingDaysInSeries);
                        
                        // Prepara i dati dell'appuntamento per la modifica con le date corrette
                        const formattedAppointment = {
                            ...appointment,
                            // Data inizio prende la data del primo appuntamento della serie
                            fromDate: firstAppointment.fromDate ? new Date(firstAppointment.fromDate).toISOString().split('T')[0] : null,
                            // Data fine prende la data dell'ultimo appuntamento della serie
                            toDate: lastAppointment.fromDate ? new Date(lastAppointment.fromDate).toISOString().split('T')[0] : null,
                            // Orari rimangono quelli dell'appuntamento corrente
                            fromTime: appointment.fromDate ? new Date(appointment.fromDate).toTimeString().slice(0, 5) : "09:00",
                            toTime: appointment.toDate ? new Date(appointment.toDate).toTimeString().slice(0, 5) : "18:00",
                        };
                        
                        setEditedAppointment(formattedAppointment);
                    } else {
                        // Se non troviamo appuntamenti nel gruppo, usa i dati dell'appuntamento corrente
                        const formattedAppointment = {
                            ...appointment,
                            fromDate: appointment.fromDate ? new Date(appointment.fromDate).toISOString().split('T')[0] : null,
                            toDate: appointment.toDate ? new Date(appointment.toDate).toISOString().split('T')[0] : null,
                            fromTime: appointment.fromDate ? new Date(appointment.fromDate).toTimeString().slice(0, 5) : "09:00",
                            toTime: appointment.toDate ? new Date(appointment.toDate).toTimeString().slice(0, 5) : "18:00",
                        };
                        
                        setEditedAppointment(formattedAppointment);
                    }
                } catch (error) {
                    console.error('Errore nel recupero degli appuntamenti del gruppo:', error);
                    toast.error('Errore nel recuperare gli appuntamenti della pianificazione');
                    
                    // In caso di errore, usa i dati dell'appuntamento corrente
                    const formattedAppointment = {
                        ...appointment,
                        fromDate: appointment.fromDate ? new Date(appointment.fromDate).toISOString().split('T')[0] : null,
                        toDate: appointment.toDate ? new Date(appointment.toDate).toISOString().split('T')[0] : null,
                        fromTime: appointment.fromDate ? new Date(appointment.fromDate).toTimeString().slice(0, 5) : "09:00",
                        toTime: appointment.toDate ? new Date(appointment.toDate).toTimeString().slice(0, 5) : "18:00",
                    };
                    
                    setEditedAppointment(formattedAppointment);
                } finally {
                    setIsLoading(false);
                }
            };
            
            fetchGroupAppointments();
        } else {
            // Per modifica singola, usa i dati dell'appuntamento corrente
            const formattedAppointment = {
                ...appointment,
                fromDate: appointment.fromDate ? new Date(appointment.fromDate).toISOString().split('T')[0] : null,
                toDate: appointment.toDate ? new Date(appointment.toDate).toISOString().split('T')[0] : null,
                fromTime: appointment.fromDate ? new Date(appointment.fromDate).toTimeString().slice(0, 5) : "09:00",
                toTime: appointment.toDate ? new Date(appointment.toDate).toTimeString().slice(0, 5) : "18:00",
            };
            
            setEditedAppointment(formattedAppointment);
        }
    };
    
    // Funzione per gestire il click sul pulsante elimina
    const handleDeleteClick = () => {
        console.log('[DEBUG] handleDeleteClick chiamato', { id: appointment._id, groupId: appointment.groupId });
        // Verifica se l'appuntamento fa parte di un gruppo (ha groupId)
        if (appointment.groupId) {
            console.log('[DEBUG] Impostando deleteMode=group per appuntamento in gruppo');
            setDeleteMode('group');
        } else {
            console.log('[DEBUG] Impostando deleteMode=single per appuntamento singolo');
            setDeleteMode('single');
        }
        console.log('[DEBUG] Impostando showDeleteModal=true');
        setShowDeleteModal(true);
        
        // Aggiungiamo un timeout per verificare lo stato dopo che il render è completato
        setTimeout(() => {
            console.log('[DEBUG] Stato della modale dopo timeout:', { 
                showDeleteModal: true, 
                deleteMode: appointment.groupId ? 'group' : 'single'
            });
        }, 100);
    };
    
    // Funzione per chiudere la modale di eliminazione
    const handleCloseDeleteModal = () => {
        console.log('[DEBUG] handleCloseDeleteModal chiamato, chiusura modale');
        setShowDeleteModal(false);
    };
    
    // Funzione per eliminare un singolo appuntamento
    const handleDeleteSingleAppointment = async () => {
        console.log('[DEBUG] handleDeleteSingleAppointment chiamato', { id: appointment._id });
        setIsDeleting(true);
        try {
            const token = localStorage.getItem('installamelo-auth-token');
            const baseUrl = getNodeApiUrl(); // Uso la funzione da api.config.js
            
            console.log('[DEBUG] Eliminazione singolo appuntamento:', { url: `${baseUrl}/appointments/${appointment._id}` });
            await axios.delete(`${baseUrl}/appointments/${appointment._id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            
            console.log('[DEBUG] Eliminazione singolo appuntamento completata con successo');
            toast.success('Appuntamento eliminato con successo');
            handleClosePanel();
        } catch (error) {
            console.error('[DEBUG] Errore durante l\'eliminazione dell\'appuntamento:', error);
            toast.error('Errore durante l\'eliminazione dell\'appuntamento');
        } finally {
            console.log('[DEBUG] Fine operazione eliminazione singolo appuntamento');
            setIsDeleting(false);
            setShowDeleteModal(false);
        }
    };
    
    // Funzione per eliminare tutti gli appuntamenti di un gruppo
    const handleDeleteGroupAppointments = async () => {
        console.log('[DEBUG] handleDeleteGroupAppointments chiamato', { groupId: appointment.groupId });
        setIsDeleting(true);
        try {
            const token = localStorage.getItem('installamelo-auth-token');
            const baseUrl = getNodeApiUrl(); // Uso la funzione da api.config.js
            
            console.log('[DEBUG] Eliminazione gruppo appuntamenti:', { url: `${baseUrl}/appointments/group/${appointment.groupId}` });
            await axios.delete(`${baseUrl}/appointments/group/${appointment.groupId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            
            console.log('[DEBUG] Eliminazione gruppo appuntamenti completata con successo');
            toast.success('Tutti gli appuntamenti del gruppo eliminati con successo');
            handleClosePanel();
        } catch (error) {
            console.error('[DEBUG] Errore durante l\'eliminazione degli appuntamenti del gruppo:', error);
            toast.error('Errore durante l\'eliminazione degli appuntamenti del gruppo');
        } finally {
            console.log('[DEBUG] Fine operazione eliminazione gruppo appuntamenti');
            setIsDeleting(false);
            setShowDeleteModal(false);
        }
    };
    
    // Funzione helper per chiudere correttamente in base all'origine
    // Se aperto dal dettaglio commessa (con oldState), torna alla commessa
    // Se aperto dalla preview appuntamento (senza oldState), chiude semplicemente
    const handleClosePanel = () => {
        if (rightModalOldState && rightModalOldState.oldMode) {
            // Aperto dal dettaglio commessa, torna alla vista precedente
            console.log('Tornando alla vista precedente (dettaglio commessa)');
            dispatch(swapModal());
            dispatch(setHasToRefresh(true));
        } else {
            // Aperto dalla preview appuntamento, chiudi semplicemente
            console.log('Chiudendo il pannello (nessuno stato precedente)');
            dispatch(closeModal());
            dispatch(setHasToRefresh(true));
        }
    };
    
    // Torna alla visualizzazione dettagli dell'appuntamento
    const handleCancelEdit = () => {
        // Usa setSwap per cambiare il contenuto del pannello senza chiuderlo
        // Impostiamo mode='view' come viene usato nel calendario per visualizzare gli appuntamenti
        dispatch(setSwap({
            id: appointment._id,
            mode: 'view',
            data: appointment,
            percentuageWidth: 80
        }));
    };
    
    // Funzione per salvare le modifiche all'appuntamento
    const handleSaveAppointment = async () => {
        if (!editedAppointment) return;
        
        // Validazione
        if (!editedAppointment.fromDate || !editedAppointment.toDate) {
            toast.warning('Seleziona data di inizio e fine');
            return;
        }
        
        if (!editedAppointment.fromTime || !editedAppointment.toTime) {
            toast.warning('Seleziona orario di inizio e fine');
            return;
        }
        
        if (editedAppointment.fromDate > editedAppointment.toDate) {
            toast.warning('La data di inizio deve essere precedente o uguale alla data di fine');
            return;
        }
        
        if (editedAppointment.fromDate === editedAppointment.toDate && 
            editedAppointment.fromTime > editedAppointment.toTime) {
            toast.warning('L\'orario di inizio deve essere precedente all\'orario di fine');
            return;
        }
        
        // Prepara l'oggetto da inviare all'API
        const toDateValue = editGroupMode ? editedAppointment.toDate : editedAppointment.fromDate; // In modalità singola, data fine = data inizio
        
        const updatedAppointment = {
            ...editedAppointment,
            fromDate: new Date(`${editedAppointment.fromDate}T${editedAppointment.fromTime}:00`).toISOString(),
            toDate: new Date(`${toDateValue}T${editedAppointment.toTime}:00`).toISOString(),
            // Converti i dati dal formato React-Select al formato originale atteso dall'API
            // IMPORTANTE: usa item.value che è l'_id dell'utente dal database (come fa SchedulingOffcanvas)
            users: selectedUsers.map(item => ({
                userId: item.value,
                userLabel: item.data?.userLabel || item.label,
                userTypeId: item.data?.userTypeId || item.data?.typeId || '',
                userTypeLabel: item.data?.userTypeLabel || item.data?.typeLabel || '',
                userMobile: item.data?.userMobile || item.data?.mobile || '',
                userEmail: item.data?.userEmail || item.data?.email || '',
                userColor: item.data?.userColor || item.data?.color || '#7367f0'
            })),
            vehicles: selectedVehicles.map(item => ({
                vehicleId: item.data?.id || item.data?._id || item.data?.vehicleId || item.value,
                vehicleLabel: item.data?.vehicleLabel || item.label
            })),
            equipments: selectedEquipments.map(item => ({
                equipmentId: item.data?.id || item.data?._id || item.data?.equipmentId || item.value,
                equipmentLabel: item.data?.equipmentLabel || item.data?.title || item.label
            })),
            // Aggiungi informazioni di account e commessa necessarie per creare nuovi appuntamenti
            accountId: appointment.accountId,
            jobId: appointment.jobId,
            // Opzioni notifiche
            notifications: {
                sendEmployeeEmail: sendEmployeeEmail,
                sendEmployeePush: sendEmployeePush,
                customerEmails: selectedCustomerEmails
            }
        };
        
        console.log('Aggiornamento appuntamento/i con:', {
            range: `${editedAppointment.fromDate} al ${editedAppointment.toDate}`,
            orari: `${editedAppointment.fromTime}-${editedAppointment.toTime}`,
            modalità: editGroupMode ? 'gruppo' : 'singolo'
        });
        
        delete updatedAppointment.fromTime;
        delete updatedAppointment.toTime;
        
        setIsSaving(true);
        
        try {
            const token = localStorage.getItem('installamelo-auth-token');
            
            // Determina quale endpoint chiamare in base alla modalità di modifica
            let apiEndpoint;
            
            if (editGroupMode) {
                // Modifica dell'intera pianificazione multi-giorno
                apiEndpoint = `/appointments/updateGroup/${appointment.groupId}`;
                updatedAppointment.groupId = appointment.groupId;
            } else {
                // Modifica singolo appuntamento
                apiEndpoint = '/appointments/updateFromPanel';
            }
            
            // Ottieni l'URL completo usando getNodeApiUrl con l'endpoint corretto
            const endpoint = getNodeApiUrl(apiEndpoint);
            
            const response = await axios.patch(endpoint, updatedAppointment, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });
            
            if (response.data && (response.data.success || response.data.result)) {
                if (editGroupMode) {
                    toast.success('Pianificazione aggiornata con successo!');
                } else {
                    toast.success('Appuntamento aggiornato con successo!');
                }
                
                // Chiudi il pannello correttamente in base all'origine
                console.log('Salvataggio completato, chiudo il pannello');
                handleClosePanel();
            }
        } catch (error) {
            console.error('Errore durante l\'aggiornamento:', error);
            toast.error(`Errore: ${error.response?.data?.message || error.message || 'Errore sconosciuto'}`);
        } finally {
            setIsSaving(false);
        }
    };
    
    // Funzione per calcolare il numero di giorni lavorativi tra due date
    const getWorkingDaysBetweenDates = (startDate, endDate) => {
        // Converti le date in oggetti Date se sono stringhe
        const start = typeof startDate === 'string' ? new Date(startDate) : new Date(startDate);
        const end = typeof endDate === 'string' ? new Date(endDate) : new Date(endDate);
        
        // Resetta le ore per evitare problemi di calcolo
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        
        // Se le date sono uguali, restituisci 1
        if (start.getTime() === end.getTime()) return 1;
        
        // Assicurati che startDate sia < endDate
        if (start > end) return 0;
        
        let count = 0;
        const current = new Date(start);
        
        // Conta tutti i giorni lavorativi nel range
        while (current <= end) {
            const dayOfWeek = current.getDay();
            // Se non è weekend (0 = Domenica, 6 = Sabato)
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                count++;
            }
            
            // Avanza di un giorno
            current.setDate(current.getDate() + 1);
        }
        
        return count;
    };
    
    // Funzione per aggiungere giorni lavorativi a una data
    const addWorkingDays = (date, days) => {
        // Crea una copia della data fissando l'orario a mezzogiorno per evitare problemi di timezone
        const result = new Date(
            date.getFullYear(), 
            date.getMonth(), 
            date.getDate(), 
            12, 0, 0
        );
        let count = 0;
        
        // Log dettagliato per debug
        console.log(`addWorkingDays - Data iniziale: ${result.toISOString().split('T')[0]}`);
        console.log(`addWorkingDays - Giorni lavorativi da aggiungere: ${days}`);
        
        // Se non ci sono giorni da aggiungere, restituisci la data originale
        if (days <= 0) {
            console.log(`addWorkingDays - Nessun giorno da aggiungere, restituisco la data originale`);
            return result;
        }
        
        // Continua ad aggiungere giorni finché non raggiungiamo il numero richiesto di giorni lavorativi
        while(count < days) {
            // Aggiungi un giorno
            result.setDate(result.getDate() + 1);
            
            // Se non è un weekend (0 = Domenica, 6 = Sabato)
            const day = result.getDay();
            if(day !== 0 && day !== 6) {
                count++;
                console.log(`addWorkingDays - Aggiunto giorno lavorativo ${count}/${days}: ${result.toISOString().split('T')[0]} (${['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'][day]})`);
            } else {
                console.log(`addWorkingDays - Saltato weekend: ${result.toISOString().split('T')[0]} (${['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'][day]})`);
            }
        }
        
        console.log(`addWorkingDays - Risultato finale: ${result.toISOString().split('T')[0]}`);
        return result;
    };
    
    // Funzioni per gestire i cambiamenti nei campi di modifica
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log('handleInputChange chiamata:', { name, value });
        
        // Se stiamo modificando la data di inizio e siamo in modalità modifica gruppo
        if (name === 'fromDate' && editGroupMode) {
            console.log('------ DEBUG INPUT CHANGE ------');
            console.log(`handleInputChange - Modalità: ${editGroupMode ? 'modifica gruppo' : 'modifica singola'}`);
            console.log(`handleInputChange - Nome campo: ${name}, Valore: ${value}`);
            console.log(`handleInputChange - groupAppointmentsCount: ${groupAppointmentsCount}`);
            
            if (groupAppointmentsCount <= 0) {
                console.warn('ATTENZIONE: Numero di giorni lavorativi nella serie non valido!');
                toast.warning('Impossibile calcolare la data di fine: giorni lavorativi sconosciuti');
                
                // Aggiorna solo la data di inizio
                setEditedAppointment(prev => ({
                    ...prev,
                    fromDate: value
                }));
                return;
            }
            
            // Conversione della nuova data di inizio in un oggetto Date
            const newFromDate = new Date(value);
            console.log(`handleInputChange - newFromDate: ${newFromDate.toISOString().split('T')[0]}`);
            
            // Non sottraiamo 1 perché groupAppointmentsCount è già il numero esatto di giorni lavorativi
            // che dobbiamo coprire. Questo è stato calcolato quando abbiamo ottenuto gli appuntamenti del gruppo.
            console.log(`handleInputChange - Giorni lavorativi da coprire: ${groupAppointmentsCount}`);
            
            // Aggiungi il numero esatto di giorni lavorativi alla data di inizio
            const newToDate = addWorkingDays(newFromDate, groupAppointmentsCount);
            const formattedToDate = newToDate.toISOString().split('T')[0];
            
            console.log(`handleInputChange - Nuova data fine calcolata: ${formattedToDate}`);
            console.log(`handleInputChange - Riepilogo: da ${value} copro ${groupAppointmentsCount} giorni lavorativi fino a ${formattedToDate}`);
            
            // Aggiorna entrambi i campi
            setEditedAppointment(prev => {
                console.log('handleInputChange - Aggiornamento stati:', {
                    fromDate: value,
                    toDate: formattedToDate,
                    prevFromDate: prev.fromDate,
                    prevToDate: prev.toDate
                });
                
                return {
                    ...prev,
                    fromDate: value,
                    toDate: formattedToDate
                };
            });
        } else if (name === 'toDate') {
            // Controllo che la data di fine non sia precedente alla data di inizio
            const fromDate = editedAppointment?.fromDate ? new Date(editedAppointment.fromDate) : null;
            const toDate = new Date(value);
            
            if (fromDate && toDate < fromDate) {
                // Se la data di fine è precedente alla data di inizio, imposta la data di fine uguale alla data di inizio
                toast.warning('La data di fine non può essere precedente alla data di inizio');
                setEditedAppointment(prev => ({
                    ...prev,
                    toDate: prev.fromDate
                }));
            } else {
                // Altrimenti aggiorna normalmente
                setEditedAppointment(prev => ({
                    ...prev,
                    [name]: value
                }));
            }
        } else {
            // Per tutti gli altri campi, aggiorna normalmente
            setEditedAppointment(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    
    // Recupera i dettagli della commessa quando il componente viene montato
    useEffect(() => {
        const fetchJobDetails = async () => {
            if (!appointment || !appointment.jobId || !accountData?._id) return;
            
            setIsLoading(true);
            setError(null);
            
            try {
                const token = localStorage.getItem('installamelo-auth-token');
                const baseUrl = import.meta.env.VITE_API_BASE_URL || '';
                
                console.log(`Richiedo dettagli commessa: ${appointment.jobId} per account: ${accountData._id}`);
                
                const response = await axios.get(`${baseUrl}/jobs`, {
                    params: {
                        accountId: accountData._id,
                        jobId: appointment.jobId,
                        token: token
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': token
                    }
                });
                
                // Verifica tutti i possibili formati di risposta e imposta i dati della commessa
                let jobData = null;
                
                console.log('Risposta completa API jobs:', response.data);
                
                if (response.data && response.data.result) {
                    jobData = response.data.result;
                } else if (response.data && response.data.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
                    jobData = response.data.data[0];
                } else if (Array.isArray(response.data) && response.data.length > 0) {
                    jobData = response.data[0];
                } else if (response.data) {
                    jobData = response.data;
                }
                
                if (jobData) {
                    console.log('Dettagli commessa estratti:', jobData);
                    console.log('systemLabel:', jobData.systemLabel);
                    console.log('systemAddressLabel:', jobData.systemAddressLabel);
                    console.log('systemTypeList:', jobData.systemTypeList);
                    console.log('jobTypeLabel:', jobData.jobTypeLabel);
                    
                    setJobDetails(jobData);
                    
                    // Recupera le email dei contatti del cliente usando customerId
                    if (appointment.customerId) {
                        fetchCustomerEmails(appointment.customerId, token);
                    } else if (jobData.customerId) {
                        fetchCustomerEmails(jobData.customerId, token);
                    }
                    
                    // Verifica se la commessa ha assistanceRequestId o maintenanceId
                    if (jobData.assistanceRequestId) {
                        console.log('Rilevata richiesta di assistenza:', jobData.assistanceRequestId);
                        fetchAssistanceDetails(jobData.assistanceRequestId, token);
                    } else if (jobData.maintenanceId) {
                        console.log('Rilevata manutenzione:', jobData.maintenanceId);
                        fetchMaintenanceDetails(jobData.maintenanceId, token);
                    }
                } else {
                    // Se non troviamo dati nella risposta, utilizziamo quelli dell'appuntamento
                    if (appointment.system) {
                        console.log('Utilizzo dati impianto da appuntamento:', appointment.system);
                        setJobDetails({
                            system: appointment.system,
                            systemLabel: appointment.system.systemLabel,
                            systemAddressLabel: appointment.system.systemAddress
                        });
                    } else {
                        setError('Nessun dettaglio commessa trovato');
                    }
                }
            } catch (error) {
                console.error('Errore nel recupero dei dettagli della commessa:', error);
                setError('Errore nel recupero dei dettagli della commessa');
                toast.error('Errore nel recupero dei dettagli della commessa');
            } finally {
                setIsLoading(false);
            }
        };
        
        // Funzione per recuperare le email dei contatti del cliente
        const fetchCustomerEmails = async (customerId, token) => {
            if (!customerId || !accountData?._id) return;
            
            try {
                const baseUrl = import.meta.env.VITE_API_BASE_URL || '';
                
                console.log(`Recupero email cliente per customerId: ${customerId}`);
                
                const response = await axios.get(`${baseUrl}/customers`, {
                    params: {
                        accountId: accountData._id,
                        customerId: customerId
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': token
                    }
                });
                
                // Estrai i dati del cliente dalla risposta
                let customerData = null;
                if (response.data?.result) {
                    customerData = response.data.result;
                } else if (response.data?.data && Array.isArray(response.data.data)) {
                    customerData = response.data.data[0];
                } else if (response.data) {
                    customerData = response.data;
                }
                
                if (customerData) {
                    const emails = [];
                    
                    // Raccogli email dai contatti
                    if (customerData.contactsList && customerData.contactsList.length > 0) {
                        customerData.contactsList.forEach(contact => {
                            if (contact.email) {
                                emails.push({
                                    email: contact.email,
                                    name: `${contact.name || ''} ${contact.surname || ''}`.trim() || 'Contatto',
                                    isMain: contact.main === true
                                });
                            }
                        });
                    }
                    
                    // Se non ci sono email nei contatti, usa l'email principale del cliente
                    if (emails.length === 0 && customerData.email) {
                        emails.push({
                            email: customerData.email,
                            name: customerData.company || customerData.customerLabel || 'Cliente',
                            isMain: true
                        });
                    }
                    
                    console.log('Email cliente recuperate:', emails);
                    setCustomerEmails(emails);
                } else {
                    console.log('Nessun dato cliente trovato');
                    setCustomerEmails([]);
                }
            } catch (error) {
                console.error('Errore recupero email cliente:', error);
                setCustomerEmails([]);
            }
        };
        
        // Funzione per recuperare i dettagli della richiesta di assistenza
        const fetchAssistanceDetails = async (assistanceRequestId, token) => {
            if (!assistanceRequestId || !accountData?._id) return;
            
            setIsLoadingExtra(true);
            setExtraDataError(null);
            
            try {
                const baseUrl = import.meta.env.VITE_API_BASE_URL || '';
                
                console.log(`Richiedo dettagli assistenza: ${assistanceRequestId} per account: ${accountData._id}`);
                
                // Uso il percorso corretto dell'API: /assistanceRequests (plurale)
                const baseEndpoint = '/assistanceRequests';
                
                console.log(`Chiamata API a: ${baseUrl}${baseEndpoint}`);
                
                
                try {
                    // Chiamata diretta all'endpoint corretto
                    const response = await axios.get(`${baseUrl}${baseEndpoint}`, {
                        params: {
                            accountId: accountData._id,
                            assistanceRequestId: assistanceRequestId,
                            token: token
                        },
                        headers: {
                            'Content-Type': 'application/json',
                            'auth-token': token
                        }
                    });
                    
                    console.log(`Risposta da ${baseEndpoint}:`, response.data);
                    
                    // Estraggo i dati a seconda del formato della risposta
                    let assistData = null;
                    const responseData = response.data;
                    
                    if (responseData.result) {
                        assistData = responseData.result;
                    } else if (responseData.data) {
                        assistData = Array.isArray(responseData.data) ? responseData.data[0] : responseData.data;
                    } else {
                        assistData = responseData;
                    }
                    
                    console.log('Dati assistenza estratti:', assistData);
                    setAssistanceData(assistData);
                    
                } catch (err) {
                    console.error(`Errore nella chiamata API ${baseEndpoint}:`, err.message);
                    setExtraDataError(`Errore nel recupero dei dettagli dell'assistenza: ${err.message}`);
                    
                    // In caso di errore mostro un messaggio chiaro
                    console.error('Impossibile recuperare i dati dell\'assistenza');
                    setExtraDataError('Impossibile recuperare i dettagli della richiesta di assistenza.');
                }
                
                /* CODICE ORIGINALE
                const response = await axios.get(`${baseUrl}/assistanceRequest`, {
                    params: {
                        accountId: accountData._id,
                        assistanceRequestId: assistanceRequestId,
                        token: token
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': token
                    }
                });
                
                if (response.data && response.data.result) {
                    console.log('Dettagli assistenza ricevuti:', response.data.result);
                    setAssistanceData(response.data.result);
                } else {
                    console.warn('Risposta API ricevuta ma senza dati dell\'assistenza');
                    setExtraDataError('Dati dell\'assistenza non disponibili');
                }
                */
            } catch (error) {
                console.error('Errore nel recupero dei dettagli dell\'assistenza:', error);
                setExtraDataError(`Errore nel recupero dei dettagli dell'assistenza: ${error.message}`);
            } finally {
                setIsLoadingExtra(false);
            }
        };
        
        // Funzione per recuperare i dettagli della manutenzione
        const fetchMaintenanceDetails = async (maintenanceId, token) => {
            if (!maintenanceId || !accountData?._id) return;
            
            setIsLoadingExtra(true);
            setExtraDataError(null);
            
            try {
                const baseUrl = import.meta.env.VITE_API_BASE_URL || '';
                
                console.log(`Richiedo dettagli manutenzione: ${maintenanceId} per account: ${accountData._id}`);
                
                const response = await axios.get(`${baseUrl}/maintenances`, {
                    params: {
                        accountId: accountData._id,
                        maintenanceId: maintenanceId,
                        token: token
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': token
                    }
                });
                
                if (response.data && response.data.result) {
                    console.log('Dettagli manutenzione ricevuti:', response.data.result);
                    setMaintenanceData(response.data.result);
                } else {
                    console.warn('Risposta API ricevuta ma senza dati della manutenzione');
                    setExtraDataError('Dati della manutenzione non disponibili');
                    // Nessun dato fake, mostro solo un messaggio di errore
                }
            } catch (error) {
                console.error('Errore nel recupero dei dettagli della manutenzione:', error);
                setExtraDataError(`Impossibile recuperare i dettagli della manutenzione.`);
            } finally {
                setIsLoadingExtra(false);
            }
        };
        
        fetchJobDetails();
    }, [appointment, accountData]);

    if (!appointment) {
        return (
            <div className="p-4">
                <h2 className="text-xl font-bold mb-4">Dettagli Appuntamento</h2>
                <p>Nessun appuntamento selezionato</p>
            </div>
        );
    }

    // Funzione per formattare le date
    const formatDate = (dateString) => {
        if (!dateString) return 'N/D';
        try {
            const date = new Date(dateString);
            return format(date, 'dd/MM/yyyy');
        } catch (error) {
            console.error('Errore nel formato della data:', error);
            return 'Formato data non valido';
        }
    };
    
    // Funzione per verificare se una data di scadenza garanzia è ancora valida
    const isWarrantyValid = (expirationDate) => {
        if (!expirationDate) return false;
        try {
            const expDate = new Date(expirationDate);
            const today = new Date();
            return expDate > today;
        } catch (error) {
            console.error('Errore nel controllo della garanzia:', error);
            return false;
        }
    };

    const formatTime = (dateString) => {
        try {
            const date = new Date(dateString);
            return format(date, "HH:mm", { locale: it });
        } catch (error) {
            console.error("Errore nella formattazione dell'ora:", error);
            return "";
        }
    };

    // Determina i colori degli utenti per visualizzazione
    const renderUserColors = () => {
        if (!appointment.users || appointment.users.length === 0) {
            return <div className="text-gray-500">Nessun utente assegnato</div>;
        }

        return (
            <div className="flex flex-wrap gap-2">
                {appointment.users.map((user, index) => (
                    <div 
                        key={index} 
                        className="px-3 py-1 rounded-full text-white flex items-center"
                        style={{ backgroundColor: user.userColor || '#7367f0' }}
                    >
                        <DynamicIcon iconClass="fa-solid fa-user mr-1" />
                        <span>{user.userLabel || 'Utente'}</span>
                    </div>
                ))}
            </div>
        );
    };

    // Determina e visualizza i veicoli
    const renderVehicles = () => {
        if (!appointment.vehicles || appointment.vehicles.length === 0) {
            return <div className="text-gray-500">Nessun veicolo assegnato</div>;
        }

        return (
            <div className="flex flex-wrap gap-2">
                {appointment.vehicles.map((vehicle, index) => (
                    <div 
                        key={index} 
                        className="px-3 py-1 rounded-full text-gray-600 flex items-center"
                    >
                        <DynamicIcon iconClass="fa-solid fa-car mr-1" />
                        <span>{vehicle.vehicleLabel || 'Veicolo'}</span>
                    </div>
                ))}
            </div>
        );
    };

    // Determina e visualizza le attrezzature
    const renderEquipments = () => {
        if (!appointment.equipments || appointment.equipments.length === 0) {
            return <div className="text-gray-500">Nessuna attrezzatura assegnata</div>;
        }

        return (
            <div className="flex flex-wrap gap-2">
                {appointment.equipments.map((equipment, index) => (
                    <div 
                        key={index} 
                        className="px-3 py-1 rounded-full text-gray-600 flex items-center"
                    >
                        <DynamicIcon iconClass="fa-solid fa-toolbox mr-1" />
                        <span>{equipment.equipmentLabel || 'Attrezzatura'}</span>
                    </div>
                ))}
            </div>
        );
    };

    // Renderizza la modale di conferma eliminazione
    // Modale per la scelta tra modifica singola o modifica gruppo
    const renderGroupEditModal = () => {
        console.log('Rendering group edit modal, showGroupEditModal:', showGroupEditModal);
        if (!showGroupEditModal) return null;
        
        return (
            <div className="fixed inset-0 flex items-center justify-center z-[9999]">
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-md w-full" style={{ backgroundColor: palette.backgroundLight }}>
                    <h3 className="text-lg font-medium mb-4" style={{ color: palette.text }}>
                        Modifica pianificazione
                    </h3>
                    <p className="mb-6" style={{ color: palette.text }}>
                        Questo appuntamento fa parte di una pianificazione con più date. Vuoi modificare solo questo appuntamento o l'intera pianificazione?
                    </p>
                    <div className="flex justify-end space-x-3">
                        <button
                            onClick={() => handleGroupEditChoice(false)}
                            className="px-4 py-2 rounded-md shadow-sm text-sm font-medium focus:outline-none"
                            style={{
                                border: `1px solid ${palette.neutralLight}`,
                                backgroundColor: palette.neutralBg || '#f1f5f9',
                                color: palette.neutralText || '#475569',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            Solo questo appuntamento
                        </button>
                        <button
                            onClick={() => handleGroupEditChoice(true)}
                            className="px-4 py-2 border-0 rounded-md shadow-sm text-sm font-medium focus:outline-none"
                            style={{
                                backgroundColor: palette.primary,
                                color: palette.textOnPrimary,
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                            }}
                        >
                            Intera pianificazione
                        </button>
                    </div>
                </div>
            </div>
        );
    };
    
    const renderDeleteModal = () => {
        console.log('[DEBUG] renderDeleteModal chiamato', { showDeleteModal, deleteMode });
        
        if (!showDeleteModal) {
            console.log('[DEBUG] renderDeleteModal: showDeleteModal è false, nessuna modale visualizzata');
            return null;
        }
        
        console.log('[DEBUG] renderDeleteModal: renderizzazione modale con deleteMode =', deleteMode);
        
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-testid="delete-modal">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                    <h2 className="text-2xl font-bold text-red-600 mb-4">
                        {deleteMode === 'single' ? 'Elimina appuntamento' : 'Elimina appuntamenti'}
                    </h2>
                    
                    <div className="mb-6">
                        {deleteMode === 'single' ? (
                            <div>
                                <p className="mb-3">Sei sicuro di voler eliminare questo appuntamento?</p>
                                <p className="text-red-600 font-medium">Attenzione: questa azione è irreversibile e non potrà essere annullata.</p>
                            </div>
                        ) : (
                            <div>
                                <p className="mb-3">Questo appuntamento fa parte di una serie di appuntamenti pianificati.</p>
                                <p className="mb-3">Seleziona un'opzione:</p>
                                <ul className="list-disc pl-5 mb-3">
                                    <li><span className="font-semibold">Elimina solo questo</span>: Rimuove soltanto l'appuntamento selezionato</li>
                                    <li><span className="font-semibold">Elimina tutti</span>: Rimuove l'intera serie di appuntamenti</li>
                                </ul>
                                <p className="text-red-600 font-medium">ATTENZIONE: Questa azione è irreversibile e non potrà essere annullata.</p>
                            </div>
                        )}
                    </div>
                    
                    <div className="flex justify-end space-x-3">
                        <button 
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 transition-colors"
                            onClick={handleCloseDeleteModal}
                            disabled={isDeleting}
                        >
                            Annulla
                        </button>
                        
                        {deleteMode === 'single' ? (
                            <button 
                                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
                                onClick={handleDeleteSingleAppointment}
                                disabled={isDeleting}
                            >
                                {isDeleting ? 'Eliminazione in corso...' : 'Elimina'}
                            </button>
                        ) : (
                            <>
                                <button 
                                    className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition-colors"
                                    onClick={handleDeleteSingleAppointment}
                                    disabled={isDeleting}
                                >
                                    {isDeleting ? 'Eliminazione in corso...' : 'Elimina solo questo'}
                                </button>
                                <button 
                                    className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
                                    onClick={handleDeleteGroupAppointments}
                                    disabled={isDeleting}
                                >
                                    {isDeleting ? 'Eliminazione in corso...' : 'Elimina tutti'}
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    };
    
    // La funzione renderEditChoiceModal è stata rimossa poiché siamo sempre in modalità modifica
    
    return (
        <div className="p-6">
            {/* Modale di scelta tra modifica singola e di gruppo */}
            {renderGroupEditModal()}
            {/* Aggiungiamo un log per verificare se stiamo tentando di renderizzare la modale di eliminazione */}
            {console.log('[DEBUG] Rendering principale, stato modale:', { showDeleteModal, deleteMode })}
            {renderDeleteModal()}
            {/* Header con solo titolo (senza X di chiusura) */}
            <div className="flex items-center justify-between p-4" 
                style={{ 
                    backgroundColor: palette.primary, 
                    borderBottom: `1px solid ${palette.neutralLight}`,
                    borderTopLeftRadius: '0.375rem',
                    borderTopRightRadius: '0.375rem'
                }}>
                <h2 className="text-lg font-semibold" style={{ color: palette.textOnPrimary }}>
                    {editMode ? `Modifica ${appointment.title || 'Appuntamento'}` : (appointment.title || 'Dettagli appuntamento')}
                </h2>
            </div>
            {editedAppointment && editMode ? (
                <div className="mb-4 p-4 rounded-lg" style={{ 
                    border: `1px solid ${palette.neutralLight}`, 
                    backgroundColor: palette.backgroundLight,
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)'
                }}>
                    
                    {/* Sezione Data e Ora */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 p-3 rounded-lg" 
                        style={{ 
                            backgroundColor: palette.secondaryBg || '#f1f5f9',
                            borderLeft: `4px solid ${palette.secondary || '#64748b'}`
                        }}>
                        <div>
                            <label className="block text-sm font-medium mb-1" style={{ color: palette.text }}>Data Inizio</label>
                            <input 
                                type="date" 
                                name="fromDate" 
                                value={editedAppointment.fromDate || ''} 
                                onChange={(e) => {
                                    const newValue = e.target.value;
                                    console.log('Input fromDate onChange chiamato direttamente:', newValue);
                                    
                                    // Aggiorna lo stato direttamente qui invece di passare attraverso handleInputChange
                                    if (editGroupMode && groupAppointmentsCount > 0) {
                                        console.log('Modalità modifica gruppo rilevata, ricalcolo la data di fine');
                                        console.log('Numero giorni lavorativi nella serie:', groupAppointmentsCount);
                                        
                                        // Converti la nuova data di inizio
                                        // Correggiamo la data per assicurarci che corrisponda ESATTAMENTE a quella selezionata
                                        const parts = newValue.split('-');
                                        // Creiamo una stringa in formato ISO ma forzando la timezone a locale
                                        const isoString = `${parts[0]}-${parts[1]}-${parts[2]}T12:00:00`;
                                        const newStartDate = new Date(isoString);
                                        
                                        try {
                                            // Calcola la nuova data di fine partendo dalla data di inizio
                                            // Sottraiamo 1 perché il primo giorno è già considerato
                                            // Se abbiamo 5 appuntamenti totali, dobbiamo aggiungere solo 4 giorni lavorativi
                                            const daysToAdd = groupAppointmentsCount - 1;
                                            console.log(`Giorni effettivi da aggiungere: ${daysToAdd} (per arrivare a ${groupAppointmentsCount} appuntamenti totali)`);
                                            const newEndDate = addWorkingDays(newStartDate, daysToAdd);
                                            const formattedEndDate = newEndDate.toISOString().split('T')[0];
                                            
                                            console.log(`Nuova data di fine calcolata: ${formattedEndDate}`);
                                            console.log(`Riepilogo: pianificazione dal ${newValue} al ${formattedEndDate}, ${groupAppointmentsCount} appuntamenti totali`);
                                            
                                            // Aggiorna entrambe le date contemporaneamente
                                            setEditedAppointment(prev => ({
                                                ...prev,
                                                fromDate: newValue,
                                                toDate: formattedEndDate
                                            }));
                                            
                                            toast.info(`Pianificazione aggiornata: ${groupAppointmentsCount} appuntamenti su ${daysToAdd + 1} giorni lavorativi`);
                                        } catch (error) {
                                            console.error('Errore nel calcolo della data di fine:', error);
                                            // In caso di errore, aggiorna solo la data di inizio
                                            setEditedAppointment(prev => ({
                                                ...prev,
                                                fromDate: newValue
                                            }));
                                        }
                                    } else {
                                        // In modalità singola, aggiorna sia la data di inizio che quella di fine (sono uguali)
                                        console.log('Modalità modifica singola, aggiorno data inizio e fine');
                                        setEditedAppointment(prev => ({
                                            ...prev,
                                            fromDate: newValue,
                                            toDate: newValue // In modalità singola, fromDate e toDate devono essere uguali
                                        }));
                                    }
                                }}
                                className="w-full rounded-md shadow-sm px-3 py-2 focus:outline-none" 
                                style={{ 
                                    border: `1px solid ${palette.neutralLight}`,
                                    backgroundColor: palette.backgroundLight,
                                    color: palette.text
                                }}
                            />
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium mb-1" style={{ color: palette.text }}>Ora Inizio</label>
                            <input 
                                type="time" 
                                name="fromTime" 
                                value={editedAppointment.fromTime || ''} 
                                onChange={(e) => {
                                    const newStartTime = e.target.value;
                                    
                                    // Aggiorna l'orario di inizio
                                    setEditedAppointment({...editedAppointment, fromTime: newStartTime});
                                    
                                    // Controllo che l'orario di inizio non sia successivo all'orario di fine
                                    if (newStartTime > editedAppointment.toTime && editedAppointment.fromDate === editedAppointment.toDate) {
                                        setEditedAppointment(prev => ({
                                            ...prev,
                                            toTime: newStartTime // Aggiorna l'orario di fine
                                        }));
                                        toast.info('L\'orario di fine è stato aggiornato per corrispondere all\'orario di inizio');
                                    }
                                }}
                                className="w-full rounded-md shadow-sm px-3 py-2 focus:outline-none" 
                                style={{ 
                                    border: `1px solid ${palette.neutralLight}`,
                                    backgroundColor: palette.backgroundLight,
                                    color: palette.text
                                }}
                            />
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium mb-1" style={{ color: palette.text }}>Data Fine</label>
                            <input 
                                type="date" 
                                name="toDate" 
                                value={editGroupMode ? (editedAppointment.toDate || '') : (editedAppointment.fromDate || '')} 
                                min={editedAppointment.fromDate} // Imposta il valore minimo alla data di inizio
                                disabled={!editGroupMode} // Disabilitato se non in modalità gruppo
                                onChange={handleInputChange}
                                className="w-full rounded-md shadow-sm px-3 py-2 focus:outline-none" 
                                style={{ 
                                    border: `1px solid ${palette.neutralLight}`,
                                    backgroundColor: palette.backgroundLight,
                                    color: palette.text
                                }}
                            />
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium mb-1" style={{ color: palette.text }}>Ora Fine</label>
                            <input 
                                type="time" 
                                name="toTime" 
                                value={editedAppointment.toTime || ''}
                                onChange={(e) => {
                                    const newEndTime = e.target.value;
                                    
                                    // In modalità singola, controlla solo che l'orario di fine non sia precedente a quello di inizio
                                    // perché la data è forzata ad essere la stessa
                                    if (newEndTime < editedAppointment.fromTime && editedAppointment.fromDate === editedAppointment.toDate) {
                                        setEditedAppointment(prev => ({
                                            ...prev, 
                                            toTime: editedAppointment.fromTime
                                        }));
                                        toast.info('L\'orario di fine non può essere precedente all\'orario di inizio');
                                    } else {
                                        setEditedAppointment(prev => ({
                                            ...prev, 
                                            toTime: newEndTime
                                        }));
                                    }
                                }}
                                className="w-full rounded-md shadow-sm px-3 py-2 focus:outline-none" 
                                style={{ 
                                    border: `1px solid ${palette.neutralLight}`,
                                    backgroundColor: palette.backgroundLight,
                                    color: palette.text
                                }}
                            />
                        </div>
                    </div>
                    
                    {/* Collaboratori */}
                    <div className="mb-5 p-3 rounded-lg" style={{ 
                        backgroundColor: palette.secondaryBg || '#f1f5f9',
                        borderLeft: `4px solid ${palette.secondary || '#64748b'}`
                    }}>
                        <label className="block text-sm font-medium mb-1" style={{ color: palette.text }}>
                            <FontAwesomeIcon icon={faUser} className="mr-2" style={{ color: palette.primary }} />
                            Collaboratori
                        </label>
                        <div className="collaboratori-wrapper">
                            <EmployeeSelect 
                                selectedOptions={selectedUsers}
                                setSelectedOptions={setSelectedUsers}
                                isMulti={true}
                                placeholder="Cerca e seleziona collaboratori..."
                                menuPortalTarget={null}
                                menuPosition="absolute"
                            />
                            <div className="text-sm mt-1" style={{ color: palette.neutralText }}>
                                Puoi selezionare più collaboratori per questo appuntamento
                            </div>
                        </div>
                    </div>
                    
                    {/* Veicoli */}
                    <div className="mb-5 p-3 rounded-lg" style={{ 
                        backgroundColor: palette.secondaryBg || '#f1f5f9',
                        borderLeft: `4px solid ${palette.secondary || '#64748b'}`
                    }}>
                        <label className="block text-sm font-medium mb-1" style={{ color: palette.text }}>
                            <FontAwesomeIcon icon={faCar} className="mr-2" style={{ color: palette.primary }} />
                            Veicoli
                        </label>
                        <div className="veicoli-wrapper">
                            <VehicleSelect 
                                selectedOptions={selectedVehicles}
                                setSelectedOptions={setSelectedVehicles}
                                isMulti={true}
                                placeholder="Cerca e seleziona veicoli..."
                                menuPortalTarget={null}
                                menuPosition="absolute"
                            />
                            <div className="text-sm mt-1" style={{ color: palette.neutralText }}>
                                Puoi selezionare più veicoli per questo appuntamento
                            </div>
                        </div>
                    </div>
                    
                    {/* Attrezzature */}
                    <div className="mb-5 p-3 rounded-lg" style={{ 
                        backgroundColor: palette.secondaryBg || '#f1f5f9',
                        borderLeft: `4px solid ${palette.secondary || '#64748b'}`
                    }}>
                        <label className="block text-sm font-medium mb-1" style={{ color: palette.text }}>
                            <FontAwesomeIcon icon={faTools} className="mr-2" style={{ color: palette.primary }} />
                            Attrezzature
                        </label>
                        <div className="attrezzature-wrapper">
                            <EquipmentSelect 
                                selectedOptions={selectedEquipments}
                                setSelectedOptions={setSelectedEquipments}
                                isMulti={true}
                                placeholder="Cerca e seleziona attrezzature..."
                                menuPortalTarget={null}
                                menuPosition="absolute"
                            />
                            <div className="text-sm mt-1" style={{ color: palette.neutralText }}>
                                Puoi selezionare più attrezzature per questo appuntamento
                            </div>
                        </div>
                    </div>
                    
                    {/* Note */}
                    <div className="mb-5 p-3 rounded-lg" style={{ 
                        backgroundColor: palette.secondaryBg || '#f1f5f9',
                        borderLeft: `4px solid ${palette.secondary || '#64748b'}`
                    }}>
                        <label className="block text-sm font-medium mb-1" style={{ color: palette.text }}>Note</label>
                        <textarea 
                            name="notes" 
                            value={editedAppointment.notes || ''} 
                            onChange={handleInputChange}
                            className="w-full rounded-md shadow-sm px-3 py-2 focus:outline-none"
                            style={{ 
                                border: `1px solid ${palette.neutralLight}`,
                                backgroundColor: palette.backgroundLight,
                                color: palette.text
                            }}
                            rows="3"
                            placeholder="Inserisci note aggiuntive..."
                        ></textarea>
                    </div>
                    
                    {/* Sezione Notifiche */}
                    <div className="mb-5 p-3 rounded-lg" style={{ 
                        backgroundColor: '#fff8e1',
                        borderLeft: `4px solid #ffc107`
                    }}>
                        <label className="block text-sm font-medium mb-3" style={{ color: palette.text }}>
                            <FontAwesomeIcon icon={faBell} className="mr-2" style={{ color: '#ffc107' }} />
                            Notifiche (opzionale)
                        </label>
                        
                        {/* Email Cliente */}
                        {(() => {
                            const availableEmails = customerEmails || [];
                            const hasCustomerEmails = availableEmails.length > 0;
                            
                            const handleEmailToggle = (email, checked) => {
                                if (checked) {
                                    setSelectedCustomerEmails(prev => [...prev, email]);
                                } else {
                                    setSelectedCustomerEmails(prev => prev.filter(e => e !== email));
                                }
                            };
                            
                            const handleSelectAll = (checked) => {
                                if (checked) {
                                    setSelectedCustomerEmails(availableEmails.map(c => c.email));
                                } else {
                                    setSelectedCustomerEmails([]);
                                }
                            };
                            
                            return (
                                <div className="p-3 mb-3 rounded" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <div className="d-flex align-items-center">
                                            <FontAwesomeIcon icon={faEnvelope} className="me-2 text-primary" />
                                            <strong>Email al Cliente</strong>
                                        </div>
                                        {hasCustomerEmails && availableEmails.length > 1 && (
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="selectAllEmailsView"
                                                    checked={selectedCustomerEmails.length === availableEmails.length}
                                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                                />
                                                <label className="form-check-label small" htmlFor="selectAllEmailsView">
                                                    Tutti
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {hasCustomerEmails ? (
                                        <div className="mt-2">
                                            {availableEmails.map((contact, idx) => (
                                                <div key={idx} className="form-check mb-1">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`viewCustomerEmail_${idx}`}
                                                        checked={selectedCustomerEmails.includes(contact.email)}
                                                        onChange={(e) => handleEmailToggle(contact.email, e.target.checked)}
                                                    />
                                                    <label className="form-check-label small" htmlFor={`viewCustomerEmail_${idx}`}>
                                                        <span className="fw-medium">{contact.name}</span>
                                                        {contact.isMain && <span className="badge bg-primary ms-1" style={{ fontSize: '0.65rem' }}>principale</span>}
                                                        <br />
                                                        <span className="text-muted">{contact.email}</span>
                                                    </label>
                                                </div>
                                            ))}
                                            {selectedCustomerEmails.length > 0 && (
                                                <small className="text-success d-block mt-2">
                                                    <FontAwesomeIcon icon={faCheck} className="me-1" />
                                                    {selectedCustomerEmails.length} email selezionat{selectedCustomerEmails.length === 1 ? 'a' : 'e'}
                                                </small>
                                            )}
                                        </div>
                                    ) : (
                                        <small className="text-warning">
                                            <FontAwesomeIcon icon={faEnvelope} className="me-1" />
                                            Nessuna email associata al cliente
                                        </small>
                                    )}
                                </div>
                            );
                        })()}
                        
                        {/* Notifiche Collaboratori */}
                        <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                            <h6 className="mb-3">
                                <FontAwesomeIcon icon={faUserGroup} className="me-2 text-info" />
                                Notifiche ai Collaboratori
                            </h6>
                            
                            {selectedUsers.length > 0 ? (
                                <>
                                    <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                                        <div className="d-flex align-items-center">
                                            <FontAwesomeIcon icon={faMobileAlt} className="me-2 text-success" />
                                            <span>Notifica Push</span>
                                        </div>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                checked={sendEmployeePush}
                                                onChange={(e) => setSendEmployeePush(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <FontAwesomeIcon icon={faEnvelope} className="me-2 text-primary" />
                                            <span>Email</span>
                                        </div>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                checked={sendEmployeeEmail}
                                                onChange={(e) => setSendEmployeeEmail(e.target.checked)}
                                            />
                                        </div>
                                    </div>
                                    <small className="text-muted d-block mt-2">
                                        Collaboratori: {selectedUsers.map(e => e.label).join(', ')}
                                    </small>
                                </>
                            ) : (
                                <small className="text-warning">
                                    Nessun collaboratore assegnato
                                </small>
                            )}
                        </div>
                    </div>
                    
                    {/* Pulsanti di azione */}
                    <div className="flex justify-end space-x-3 mt-6 pt-4" style={{ 
                        borderTop: `1px solid ${palette.neutralLight}`
                    }}>
                        <button
                            onClick={handleCancelEdit}
                            className="px-4 py-2 rounded-md shadow-sm text-sm font-medium focus:outline-none"
                            style={{
                                border: `1px solid ${palette.neutralLight}`,
                                backgroundColor: palette.neutralBg || '#f1f5f9',
                                color: palette.neutralText || '#475569',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                transition: 'all 0.2s ease-in-out'
                            }}
                            disabled={isSaving}
                        >
                            Annulla
                        </button>
                        <button
                            onClick={handleSaveAppointment}
                            className="px-4 py-2 border-0 rounded-md shadow-sm text-sm font-medium focus:outline-none"
                            style={{
                                backgroundColor: palette.primary,
                                color: palette.textOnPrimary,
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                                transition: 'all 0.2s ease-in-out',
                                fontWeight: 500
                            }}
                            disabled={isSaving}
                        >
                            {isSaving ? 'Salvataggio...' : (editGroupMode ? 'Modifica intera pianificazione' : 'Salva')}
                        </button>
                    </div>
                </div>
            ) : editedAppointment && (
                <div className="p-4">
                    {/* Header con codice commessa e cliente */}
                    <div className="border-b pb-2 mb-4">
                        <h3 className="text-lg font-bold">
                            {appointment.jobId ? `${appointment.jobId} ` : ''}
                            {appointment.customer ? appointment.customer.toUpperCase() : ''}
                        </h3>
                    </div>
                    
                    {/* Data e Ora */}
                    <div className="mb-6">
                        <h4 className="text-base font-semibold mb-2">Data e Ora</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <p className="text-xs text-gray-500">Inizio</p>
                                <p className="text-sm">
                                    {appointment.fromDate ? format(new Date(appointment.fromDate), 'dd/MM/yyyy') : ''}
                                    {appointment.fromDate ? ':' + format(new Date(appointment.fromDate), 'HH:mm') : ''}
                                </p>
                            </div>
                            <div>
                                <p className="text-xs text-gray-500">Fine</p>
                                <p className="text-sm">
                                    {appointment.toDate ? format(new Date(appointment.toDate), 'dd/MM/yyyy') : ''}
                                    {appointment.toDate ? ':' + format(new Date(appointment.toDate), 'HH:mm') : ''}
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    {/* Collaboratori */}
                    {selectedUsers && selectedUsers.length > 0 && (
                        <div className="mb-6">
                            <h4 className="flex items-center text-base font-semibold mb-2">
                                <FontAwesomeIcon icon={faUser} className="mr-2" />
                                Collaboratori
                            </h4>
                            <div>
                                {selectedUsers.map((user, index) => (
                                    <span key={index} className="text-sm mr-2">{user.label}</span>
                                ))}
                            </div>
                        </div>
                    )}
                    
                    {/* Pulsanti */}
                    <div className="flex justify-end space-x-2 mt-8">
                        <button
                            onClick={handleEditClick}
                            className="px-4 py-2 rounded shadow-sm transition-colors"
                            style={{
                                backgroundColor: palette.primary,
                                color: palette.textOnPrimary,
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
                            }}
                        >
                            Modifica
                        </button>
                        <button
                            onClick={handleClosePanel}
                            className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-100 transition-colors"
                        >
                            Chiudi
                        </button>
                    </div>
                </div>
            )}        
        </div>
    );
}
